export default __webpack_public_path__ + "static/media/next-elevate.dedb2d4c.jpg";